import * as React from "react"

const LogoTokoramePoint = (props) => (
  <svg
    width={106}
    height={105}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#a)">
      <rect x={8} y={4} width={89.591} height={89} rx={14} fill="#fff" />
      <path d="m46.24 16-4.37 11.404H20L26.426 16h19.815Z" fill="#36F" />
      <path
        d="M63.72 27.404H41.87L46.199 16H59.95l3.77 11.404Z"
        fill="#F43D8D"
      />
      <path d="M85.59 27.404H63.72L59.907 16H79.25l6.34 11.404Z" fill="#36F" />
      <path
        d="M20 27.404v42.498C20 75.909 25.012 81 30.925 81c5.912 0 10.924-5.09 10.924-11.098V27.404H20Z"
        fill="#3333B0"
      />
      <path
        d="M41.87 27.404v42.498C41.87 75.909 46.884 81 52.796 81c5.913 0 10.925-5.09 10.925-11.098V27.404H41.87Z"
        fill="#D10B54"
      />
      <path
        d="M63.72 27.404v42.498C63.72 75.909 68.733 81 74.645 81c5.912 0 10.925-5.09 10.925-11.098V27.404H63.72Z"
        fill="#3333B0"
      />
      <path
        d="M34.18 35.447c.151.224.28.489.388.754-.13-.265-.258-.51-.387-.754ZM71.196 35.305c-.171.346-.343.692-.535 1.018.128-.367.3-.713.535-1.018Z"
        fill="#fff"
      />
      <path
        d="M34.568 36.18c-.13-.244-.258-.489-.387-.754.172.245.3.49.387.754ZM71.196 35.305c-.171.346-.343.692-.535 1.018.128-.367.3-.713.535-1.018Z"
        fill="#979798"
      />
      <path
        d="M77.965 37.34c0 .387-.064.754-.193 1.1-.128.285-.278.57-.428.855-4.563 8.553-13.902 14.397-24.677 14.397-10.69 0-19.964-5.763-24.57-14.213a69.542 69.542 0 0 1-.643-1.242 3.13 3.13 0 0 1-.128-.896c0-1.955 1.67-3.544 3.727-3.544 1.328 0 2.485.652 3.15 1.63.128.244.235.488.385.753v.02c3.363 6.231 10.196 10.508 18.079 10.508 7.819 0 14.609-4.215 18.015-10.386.193-.346.364-.672.535-1.018a3.79 3.79 0 0 1 3.042-1.507c2.035.02 3.706 1.589 3.706 3.544Z"
        fill="#fff"
      />
      <path
        d="M27.454 38.257c.193.408.407.835.643 1.242a3.313 3.313 0 0 1-.643-1.242ZM34.568 36.18c-.13-.244-.258-.489-.387-.754.172.245.3.49.387.754ZM70.66 36.343c.13-.367.3-.713.536-1.018-.171.325-.343.672-.535 1.018ZM77.772 38.44c-.107.306-.257.59-.428.855.15-.264.3-.55.428-.855Z"
        fill="#B3B3B5"
      />
    </g>
    <mask
      id="b"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={6}
      y={3}
      width={31}
      height={31}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.334 32.645c8.468 0 15.333-6.636 15.333-14.823C36.667 9.636 29.802 3 21.334 3 12.865 3 6 9.636 6 17.822c0 3.663 1.374 7.015 3.651 9.602L8.05 31.979c-.3.854.597 1.644 1.45 1.275l4.989-2.16.004-.002a15.703 15.703 0 0 0 6.84 1.553Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#b)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.334 32.645c8.468 0 15.333-6.636 15.333-14.823C36.667 9.636 29.802 3 21.334 3 12.865 3 6 9.636 6 17.822c0 3.663 1.374 7.015 3.651 9.602L8.05 31.979c-.3.854.597 1.644 1.45 1.275l4.989-2.16.004-.002a15.703 15.703 0 0 0 6.84 1.553Z"
        fill="#F2C94C"
      />
      <path
        d="m9.651 27.424 1.012.332.195-.555-.393-.447-.814.67ZM8.05 31.979l-1.012-.333 1.012.333Zm1.449 1.275.437.943-.437-.943Zm4.99-2.16.437.943-.437-.943Zm.004-.002.477-.925-.455-.22-.463.203.44.942Zm21.105-13.27c0 7.616-6.386 13.79-14.265 13.79v2.066c9.06 0 16.403-7.099 16.403-15.855h-2.138ZM21.333 4.034c7.879 0 14.265 6.174 14.265 13.79h2.138c0-8.757-7.344-15.856-16.403-15.856v2.066ZM7.07 17.823c0-7.616 6.386-13.79 14.264-13.79V1.967c-9.058 0-16.402 7.099-16.402 15.856h2.138Zm3.396 8.931C8.346 24.347 7.07 21.23 7.07 17.823H4.93c0 3.916 1.47 7.504 3.906 10.27l1.628-1.339Zm-1.403 5.557 1.601-4.555-2.024-.665-1.601 4.555 2.024.665Zm0 0-2.024-.665c-.601 1.71 1.194 3.29 2.898 2.551l-.874-1.886Zm4.99-2.16-4.99 2.16.874 1.886 4.99-2.16-.874-1.886Zm0 0 .874 1.885a.14.14 0 0 1 .006-.002h.001v-.001l-.881-1.883Zm7.281 1.46c-2.288 0-4.448-.52-6.363-1.444l-.955 1.85a16.8 16.8 0 0 0 7.318 1.661v-2.066Z"
        fill="#F9A33D"
      />
      <path
        d="M21.334 28.423c6.056 0 10.965-4.746 10.965-10.6 0-5.855-4.91-10.6-10.965-10.6-6.056 0-10.966 4.745-10.966 10.6 0 5.854 4.91 10.6 10.966 10.6Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.495 20.543c-.06 1.145-1.07 2.027-2.254 1.97-1.186-.058-2.098-1.034-2.038-2.18l-1.068-.052c-.09 1.716 1.277 3.177 3.052 3.264 1.775.086 3.286-1.235 3.376-2.95.024-.462-.07-1.102-.518-1.768-.36-.536-.934-1.064-1.81-1.528l.023-.105a6.438 6.438 0 0 1-.457-.109 9.314 9.314 0 0 0-.255-.111l-.013.03c-1.779-.588-2.343-1.767-2.417-2.222-.183-1.134.62-2.196 1.792-2.373 1.173-.177 2.272.599 2.455 1.732l1.056-.159c-.274-1.697-1.92-2.859-3.675-2.594-1.756.265-2.958 1.856-2.684 3.553.142.877 1.045 2.437 3.356 3.112.939.44 1.453.92 1.733 1.337.308.458.36.874.346 1.153Z"
        fill="#F9A33D"
      />
      <path
        d="M21.334 10.411h-.767v1.483h.767V10.41ZM22.1 23.01h-.766v1.482h.766V23.01Z"
        fill="#F9A33D"
      />
    </g>
    <defs>
      <filter
        id="a"
        x={0}
        y={0}
        width={105.591}
        height={105}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={4} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_819_6652"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_819_6652"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)

export default LogoTokoramePoint